import React from 'react';
import desk from '../assets/images/about/desktop.png'
import logolong from '../assets/images/Logo_long.webp';
const InfoClient = () => {
    return (
        <section id="aboutcontainer" className="about-area about-five">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="about-image2" id="img2back">
                            <img src={desk} alt="about"
                                id="image2" />
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="about-image2-content">
                            <img className="AboutLogo" src={logolong}
                                alt="Logo" />
                            <div className="about-five-tab">
                                <nav>
                                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                                        <button className="nav-link active" id="nav-who-tab"
                                            data-bs-toggle="tab" data-bs-target="#nav-who"
                                            type="button" role="tab" aria-controls="nav-who"
                                            aria-selected="true">Qui sommes nous?</button>
                                        <button className="nav-link" id="nav-vision-tab"
                                            data-bs-toggle="tab" data-bs-target="#nav-vision"
                                            type="button" role="tab" aria-controls="nav-vision"
                                            aria-selected="false">Notre mission</button>
                                    </div>
                                </nav>
                                <div className="tab-content" id="nav-tabContent">
                                    <div className="tab-pane fade show active" id="nav-who"
                                        role="tabpanel" aria-labelledby="nav-who-tab">
                                        <p>
                                            Impôts MaxDC est un service professionnel de préparation
                                            de déclarations de revenus à distance. Une équipe avec plus de
                                            15 ans d’expérience, qui aide ses clients à maximiser tous les crédits auxquels ils ont droit. </p>
                                    </div>
                                    <div className="tab-pane fade" id="nav-vision" role="tabpanel"
                                        aria-labelledby="nav-vision-tab">
                                        <p>
                                            Établir une relation à long terme avec nos clients, leur
                                            offrir des solutions pratiques et éclairées afin qu’ils puissent
                                            mieux comprendre leur situation fiscale grâce aux
                                            conseils fiables d'une équipe qualifiée. </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default InfoClient;